import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftRight, Plus } from 'react-bootstrap-icons';
import Provider from './provider';
import { TPlatform } from './types';
import './Platform.scss';

const Platform: React.FC<TPlatform> = ({ connected_platforms }) => {
  const { t } = useTranslation();

  return (
    <div className="import-data-modal-platform-container">
      <h4 className="import-data-modal-platform-title">
        {t('import_data.import_data_modal.1.not_connected.title')}
      </h4>
      <hr />
      <div className="import-data-modal-platform">
        <Provider
          title={t('import_data.import_data_modal.1.platform.title.google')}
          icon={<ArrowLeftRight />}
          button={t('import_data.import_data_modal.1.not_connected.button')}
          description={t(
            'import_data.import_data_modal.1.not_connected.description',
            { provider: 'Google Ads' }
          )}
        />
        <Provider
          title={t('import_data.import_data_modal.1.platform.title.tiktok')}
          icon={<ArrowLeftRight />}
          button={t('import_data.import_data_modal.1.not_connected.button')}
          description={t(
            'import_data.import_data_modal.1.not_connected.description',
            { provider: 'TikTok' }
          )}
        />
        <Provider
          title={t('import_data.import_data_modal.1.platform.title.meta')}
          icon={<ArrowLeftRight />}
          button={t('import_data.import_data_modal.1.not_connected.button')}
          description={t(
            'import_data.import_data_modal.1.not_connected.description',
            { provider: 'business' }
          )}
        />
      </div>
      <h4 className="import-data-modal-platform-title">
        {t('import_data.import_data_modal.1.connected.title')}
      </h4>
      <hr />
      <div className="import-data-modal-platform-connected">
        {connected_platforms?.map((accounts) => (
          <Provider
            title={t(
              `import_data.import_data_modal.1.platform.title.${accounts.id}`
            )}
            icon={<Plus />}
            button={t('import_data.import_data_modal.1.connected.button')}
            description={t(
              'import_data.import_data_modal.1.connected.description'
            )}
            name={accounts.adAccountName}
            withRemove
          />
        ))}
      </div>
    </div>
  );
};

export default Platform;
